import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import VueAxios from 'vue-axios';
// import 'bootstrap/dist/css/bootstrap.css'

// require('bootstrap')
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';

Vue.config.productionTip = false;
// Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.use(VueAxios,axios);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
